<template>
  <a-modal
    :title="$t('page_plan_process_flow_card')"
    :visible="visible"
    @cancel="cancel"
    :destroyOnClose="true"
    :width="1366"
    :maskClosable="false"
  >
    <template slot="footer">
      <div class="product-print-footer">
        <a-button key="back" @click="cancel">
          {{ $t('cancel') }}
        </a-button>
        <a-button key="submit" type="primary" @click="download">
          {{ $t('page_my_document_download') }}
        </a-button>
        <div class="product-print-button">
          <a-button key="back" @click="print">
            {{ $t('page_product_printing') }}
          </a-button>
          建议采用A4打印
        </div>
      </div>
    </template>
    <div v-if="loading" style="text-align: center; padding: 200px 0">
      <a-spin />
    </div>
    <div v-else class="print-container" id="print-container">
      <h1>{{ $t('page_plan_process_flow_card') }}</h1>
      <table>
        <tr>
          <td>{{ $t('page_plan_production_plan_no') }}</td>
          <td>{{ cardData.code }}</td>
          <td>{{ $t('page_plan_order_no') }}</td>
          <td>{{ cardData.orderCode }}</td>
        </tr>
        <tr>
          <td>{{ $t('page_product_name') }}</td>
          <td>{{ $t('page_plan_product_no') }}</td>
          <td>{{ $t('page_plan_stardard_model') }}</td>
          <td>{{ $t('page_plan_craft_version') }}</td>
        </tr>
        <tr>
          <td>{{ cardData.productionName }}</td>
          <td>{{ cardData.productionCode }}</td>
          <td>{{ cardData.standardModel }}</td>
          <td>{{ cardData.version }}</td>
        </tr>
        <tr>
          <td>{{ $t('page_plan_craft_name') }}</td>
          <td>{{ $t('page_plan_craft_sort') }}</td>
          <td>{{ $t('page_plan_barcode') }}</td>
          <td>{{ $t('page_plan_procedure_number') }}</td>
        </tr>
        <tr v-for="(item, index) in cardData.productionOrderProcessBO" :key="index">
          <td>{{ item.processName }}</td>
          <td>{{ item.sort }}</td>
          <td>
            <img style="max-width: 300px; max-height: 160px;" :id="'barcode-' + item.sort" />
          </td>
          <td>{{ item.programName }}</td>
        </tr>
      </table>
    </div>
  </a-modal>
</template>

<script>
import jsbarcode from 'jsbarcode'
import { setLocalStorage } from '@/utils/storage'
export default {
  data() {
    return {}
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    cardData: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cardData: {
      handler() {
        if (this.cardData && this.cardData.productionOrderProcessBO.length) {
          setTimeout(() => {
            this.jsbar()
          }, 500)
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    async jsbar() {
      await this.$nextTick()
      this.cardData.productionOrderProcessBO.map((item) => {
        const options = {
          text: this.cardData.orderCode + '-' + item.sort + '-' + item.processCode
        }
        console.log(options)
        jsbarcode('#barcode-' + item.sort, item.id, options)
      })
    },
    print() {
      this.$store.state.cardPrintData = this.cardData
      setLocalStorage('cardPrintData', this.cardData)
      this.$nextTick(() => {
        window.open('/job/point')
      })
    },
    download() {
      this.$emit('download')
    }
  }
}
</script>

<style lang="less" scoped></style>
